<template>
  <div class="log list-item"
       :class="{ owner: isLogOwner }"
        @click="editLog">
    <client-code v-if="showClientCode && !log.client_icon_url" :code="log.client_code" :seed="log.client_name"/>
    <img v-if="showClientCode && log.client_icon_url" :src="log.client_icon_url" class="client-code"/>
    <div class="content">
      <div class="top">
        <div class="info">
          <div class="title" v-if="showProjectTitle"><b>{{ log.client_name }} - {{ log.project_code }}</b></div>
          <div class="title" v-if="showTaskTitle && showProjectTitle">
            <span v-if="showTaskProjectName">{{ log.project_name }} - </span>{{ log.task_title }}
          </div>
          <div class="title" v-if="showTaskTitle && !showProjectTitle">
            <b><span v-if="showTaskProjectName">{{ log.project_name }} - </span>{{ log.task_title }}</b>
          </div>
          <div class="date" v-if="showTaskDate">{{ logTime(log) }} | {{ log.user_full_name }}</div>
        </div>
        <div class="timer">
          <icon name="regular/clock" />
          <span class="total-time" >{{ logAsTime(log) }}</span>
        </div>
      </div>
      <div class="bottom" v-if="showComment">
        <div class="tag" v-if="tag">{{ tag.tag }}</div>
        <div class="comment">{{ log.comment || 'no comment' }}</div>
      </div>
    </div>
    <log-crud v-if="isLogOwner && showLogCrud"
              :log="log"
              @close="logCrudClose" />
  </div>
</template>

<script>
  import { mixin as LogTimes } from '../../../mixins/LogTimes'
  import { mixin as Utils } from '../../../mixins/Utils'
  export default {
    name: 'log',
    mixins: [LogTimes, Utils],
    props: {
      showClientCode: { default: false },
      showProjectTitle: { default: true },
      showTaskProjectName: { default: false },
      showTaskTitle: { default: true },
      showTaskDate: { default: true },
      showComment: { default: true },
      log: null
    },
    data () {
      return {
        showLogCrud: false,
        editingLog: false,
        editLogStartTime: null,
        editLogStartDate: null,
        editLogEndTime: null,
        editLogEndDate: null,
        editLogComment: null,
        startTimeValidationMsg: '',
        startDateValidationMsg: '',
        endTimeValidationMsg: '',
        endDateValidationMsg: ''
      }
    },
    methods: {
      editLog () {
        if (this.isLogOwner) {
          this.showLogCrud = true
        }
      },
      logCrudClose () {
        this.showLogCrud = false
      }
    },
    computed: {
      // Vuex Mappings
      isLogOwner () {
        return this.currentUser.id === this.log.user_id || this.isAdmin
      },
      tag () {
        if (this.log && this.log.tag_id) {
          return this.tags[this.log.tag_id]
        }
        return null
      },
      currentUser () {
        return this.$store.state.users.currentUser
      },
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      tags () {
        return this.$store.state.tags.objects
      }
    }
  }
</script>
<style lang="less" rel="stylesheet/less">
  .log {
    border-bottom: 1px solid #e6e6e6;
    background-color: #FFF;
    padding: 20px;
    display: flex;
    align-items: center;
    @media screen and (max-width: 520px) {
      padding: 10px 15px;
    }
    .content {
      flex: 1;
      .info {
        flex: 1;
        white-space: normal;
        padding-right: 10px;
      }

      @media screen and (max-width: 520px) {
        .client-code {
          margin-right: 10px;
        }
      }
    }

    .top {
      display: flex;
      align-items: center;
    }

    &.owner {
      cursor: pointer;
    }

    .title,
    .comment {
      font-size: 0.9em;
    }
    .tag {
      font-size: 0.8em;
    }
    .comment {
      color: #606266;
      white-space: pre-wrap;
    }

    .client-code {
      display: inline-block;
    }
    .info {
      display: inline-block;
      vertical-align: middle;
    }
  }
</style>
